import React, { useState, useMemo, useEffect } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { z } from "zod";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import i1 from "../../../../Assets/images/authBg.png";
import {
  catchAsync,
  checkResponse,
} from "../../../../utilities/utilities";
import {

  ADD_PROMOTION,
  UPDATE_PROMOTION,
  GET_PROMOTION_BY_ID,
  HOTELLIST,
} from "../../../../services/ApiCalls";
import Loader from "../../../../components/Common/Loader";
import uploadMultipleFiles from "../../../../utilities/uploadMultipleFiles";
import Loading from "../../../../components/Common/Loading";
import { useTranslation } from "react-i18next";

const getSchema = (id) =>
  z
    .object({
      name: z.string({ required_error: "Promotion name is required" }),
      countryName: z.string({ required_error: "Country is required" }),
      priority: z.number({ required_error: "Priority is required" }),
      description: z.string({ required_error: "Promotion description is required" }),
      startDate: z.string({ required_error: "Start Date is required" }),
      endDate: z.string({ required_error: "End Date is required" }),
      deepLinkType: z.string({ required_error: "Deep Link Type is required" }),
      image: id
        ? z.string().optional()
        : z.string({ required_error: "Image is required" }),
      status: z.string({ required_error: "Status is required" }),

      // Make optional initially
      hotelId: z.string().optional(),
      url: z.string().optional(),
    })
    .superRefine((data, ctx) => {
      if (data.deepLinkType === "hotel" && !data.hotelId) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Hotel is required when Deep Link Type is Hotel",
          path: ["hotelId"],
        });
      }

      if (data.deepLinkType === "external" && !data.url) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "URL is required when Deep Link Type is External",
          path: ["url"],
        });
      }
    });

const AddPromotion = () => {
  const [promoCodeDetails, setPromocodeDetails] = useState();
  const formatDateForInput = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toISOString().split("T")[0];
};
  const [imagePreview, setImagePreview] = useState(null,
  );
  const [hList,setHList]=useState([])
  const { id } = useParams();

  const schema = useMemo(() => getSchema(id), [id]);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [loader, setLoader] = useState();
  const [imgloader, setImgLoader] = useState(false);

  const [submitLoader, setSubmitLoader] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    
    watch,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      status: "active",
    },
    values: {
      name: promoCodeDetails?.name || "",
      description: promoCodeDetails?.description || "",
      status: promoCodeDetails?.status || "",
      image: promoCodeDetails?.image?._id || "",
      countryName: promoCodeDetails?.countryName || "",
      priority: promoCodeDetails?.priority || "",
      startDate: formatDateForInput(promoCodeDetails?.startDate),
  endDate: formatDateForInput(promoCodeDetails?.endDate),
      deepLinkType:promoCodeDetails?.deepLinkType||"",
      hotelId:promoCodeDetails?.hotelId||"",
      url: promoCodeDetails?.url||""
    },
  });
  useEffect(()=>{
    setValue("hotelId",promoCodeDetails?.hotelId)

  },[hList])
const deepLinkType = watch("deepLinkType");
  const handleImageChange = catchAsync(async (e) => {
    setImgLoader(true);
    const file = e.target.files;
    const res = await uploadMultipleFiles(file);

    setValue("image", res[0]?._id);
    setImgLoader(false);
    setImagePreview(res[0]?.link)
  });

  const submitHandler = catchAsync(async (data) => {

    const body = {
      ...data,
      ...(id && { _id: id }),
      status: data.status,
    };

    const res = await (id ? UPDATE_PROMOTION(body) : ADD_PROMOTION(body));
    const success = checkResponse({
      res,
      showSuccess: true,
      setLoader: setSubmitLoader,
    });

    if (success) {
      navigate("/promotion");
    }
  }, setSubmitLoader);

  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await GET_PROMOTION_BY_ID(id);
    setImagePreview(res?.data?.data?.image?.link);
    const success = checkResponse({
      res,
      setData: setPromocodeDetails,
      setLoader,
    });
  }, setLoader);

  useEffect(() => {
    if (id) getData();
  }, [id]);
  useEffect(()=>{
HOTELLIST({page:1,limit:100000}).then((res)=>{
  setHList(res.data.data.hotelList)
})
  },[])

  const handleCancel = () => {
    navigate("/promotion");
  };


  const handleRemoveImage = () => {
    setImagePreview(null);

    setValue(
      "image", "",
      { shouldValidate: true }
    );
  }
  return (
    <>
      {loader && <Loader />}
      <section className="addPromo position-relative py-3">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Link
                  to="/promotion"
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#E8307A"
                      stroke="#E8307A"
                      stroke-width="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {id ? t("promotion.editPropmotion") : t("promotion.addLabelPropmotion")}
                </h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div
                className="formWrapper px-lg-5 p-md-4 p-3 rounded"
                style={{ background: "#EEEEEE" }}
              >
                <Form onSubmit={handleSubmit(submitHandler)}>
                  <Row className="justify-content-between">
                    <Col lg="5" md="6" className="my-2">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          {t("promotion.form.promotionName")}
                        </label>
                        <input
                          type="text"
                          required
                          placeholder="Enter Name"
                          className="form-control"
                          {...register("name")}
                        />
                        {errors?.name && (
                          <p className="text-danger m-0">
                            {errors?.name?.message}
                          </p>
                        )}
                      </div>
                    </Col>
                    <Col lg="5" md="6" className="my-2">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          {t("promotion.form.startDate", "Start Date")}
                        </label>
                        <input
                          type="date"
                          required
                          // placeholder="Enter Name"
                          className="form-control"
                          {...register("startDate")}
                        />
                        {errors?.startDate && (
                          <p className="text-danger m-0">
                            {errors?.name?.startDate}
                          </p>
                        )}
                      </div>
                    </Col>

                    <Col lg="5" md="6" className="my-2">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          {t("promotion.form.endDate", "End Date")}
                        </label>
                        <input
                          type="date"
                          required
                          // placeholder="Enter Name"
                          className="form-control"
                          {...register("endDate")}
                        />
                        {errors?.endDate && (
                          <p className="text-danger m-0">
                            {errors?.name?.endDate}
                          </p>
                        )}
                      </div>
                    </Col>
                    <Col lg="5" md="6" className="my-2">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          {t("promotion.form.description")}
                        </label>
                        <input
                          type="text"
                          required
                          placeholder="Enter Description"
                          className="form-control"
                          {...register("description")}
                        />
                        {errors?.description && (
                          <p className="text-danger m-0">
                            {errors?.description?.message}
                          </p>
                        )}
                      </div>
                    </Col>
                    <Col lg="5" md="6" className="my-2">
                      <div className="py-2">
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          {t("promotion.form.StatusofPromotion")}
                        </label>
                        <select
                          className="form-control"
                          required
                          {...register("status")}
                        >
                          <option value="" disabled>
                            Select Status
                          </option>
                          {["Active", "InActive", "Deleted"].map((status) => (
                            <option key={status} value={status.toLowerCase()}>
                              {status}
                            </option>
                          ))}
                        </select>
                        {errors?.status && (
                          <p className="text-danger m-0">{errors?.status?.message}</p>
                        )}
                      </div>
                    </Col>
                    <Col lg="5" md="6" className="my-2">
                      <div className="py-2">
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          {t("promotion.form.country")}
                        </label>
                        <select
                          className="form-control"
                          {...register("countryName")}
                          defaultValue=""
                          required
                        >
                          <option value="" disabled>
                            Select Country
                          </option>
                          {['Vietnam', 'Thailand', 'India', 'Global'].map((ctry) => (
                            <option key={ctry} value={ctry}>
                              {ctry}
                            </option>
                          ))}
                        </select>
                        {errors?.countryName && (
                          <p className="text-danger m-0">{errors?.countryName?.message}</p>
                        )}
                      </div>
                    </Col>
                    <Col lg="5" md="6" className="my-2">
                      <div className="py-2">
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          {t("promotion.form.priority", "Priority")}
                        </label>
                        <select
                          className="form-control"
                          {...register("priority", { valueAsNumber: true })}
                          defaultValue=""
                          required
                        >
                          <option value="" disabled>
                            Select Priority
                          </option>
                          <option value={1} >
                            High
                          </option>
                          <option value={2} >
                            Moderate
                          </option>
                          <option value={3}>
                            Low
                          </option>
                        </select>
                        {errors?.priority && (
                          <p className="text-danger m-0">{errors?.priority?.message}</p>
                        )}
                      </div>
                    </Col>

                     <Col lg="5" md="6" className="my-2">
                      <div className="py-2">
                        <label className="form-label fw-sbold text-muted ps-2 m-0">
                          {t("promotion.form.deepLinkType", "Deep Link Type")}
                        </label>
                        <select
                          className="form-control"
                          {...register("deepLinkType")}
                          defaultValue=""
                          required
                        >
                          <option value="" disabled>
                            Select Deep Link Type
                          </option>
                          <option value="hotel" >
                            Hotel
                          </option>
                          <option value="external" >
                            External
                          </option>
                          
                        </select>
                        {errors?.deepLinkType && (
                          <p className="text-danger m-0">{errors?.deepLinkType?.message}</p>
                        )}
                      </div>
                    </Col>
                       {deepLinkType === "hotel" && (
  <Col lg="5" md="6" className="my-2">
     <div className="py-2">
      <label className="form-label fw-sbold text-muted ps-2 m-0">
                          {t("promotion.form.hotel", "Hotel")}
                        </label>
    <select className="form-control" {...register("hotelId")}>
      <option value="">Select Hotel</option>
      {hList.map((hotel) => (
        <option key={hotel._id} value={hotel._id}>
          {hotel.hotelName}
        </option>
      ))}
    </select>
    {errors?.hotelId && (
      <p className="text-danger">{errors.hotelId.message}</p>
    )}</div>
  </Col>
)}

{deepLinkType === "external" && (
  <Col lg="5" md="6" className="my-2">
         <div className="py-2">
           <label className="form-label fw-sbold text-muted ps-2 m-0">
                          {t("promotion.form.url", "URL")}
                        </label>

    <input
      type="text"
      placeholder="Enter URL"
      className="form-control"
      {...register("url")}
    />
    {errors?.url && (
      <p className="text-danger">{errors.url.message}</p>
    )}
    </div>
  </Col>
)}

                    <Col lg="12" md="12" className="my-2 position-relative">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          {t("promotion.form.promotionImage")}
                        </label>
                        <input
                          type="file"
                          accept="image/*"
                          className="form-control"
                          onChange={handleImageChange}
                        />
                        {errors?.image && (
                          <p className="text-danger m-0">
                            {errors?.image?.message}
                          </p>
                        )}
                        {imgloader ? (
                          <div
                            style={{ height: 40, width: 40 }}
                            className="img-fluid rounded-circle position-absolute end-50 mt-1  object-fit-cover"
                          >
                            <Loading fullSize={true} />
                          </div>
                        ) : (
                          <>
                            {imagePreview && (
                              <img

                                src={imagePreview}
                                alt="Promotion Preview"
                                style={{ width: "50%", marginTop: "10px", marginLeft: "25%" }}
                              />
                            )}
                          </>
                        )}
                      </div>
                    </Col>

                    <Col lg="12" className="my-2 mt-5">
                      <div className="d-flex align-items-center justify-content-center gap-10">
                        <Button
                          disabled={submitLoader}
                          type="button"
                          onClick={handleCancel}
                          className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                        >
                          {t('promotion.form.cancel')}
                        </Button>
                        <Button
                          disabled={submitLoader}
                          type="submit"
                          className="d-flex align-items-center justify-content-center commonBtn"
                        >
                          {t('promotion.form.submit')}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddPromotion;
